import React from 'react';
import video2 from '../assets/videos/video_2.mp4';

const Tarifs = () => {
    return (
        <div>
            {/* Hero/Video Section for Tarifs */}
            <section style={{ position: 'relative', height: '60vh', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white' }}>
                <video
                    autoPlay
                    loop
                    muted
                    playsInline
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        minWidth: '100%',
                        minHeight: '100%',
                        width: 'auto',
                        height: 'auto',
                        zIndex: -1,
                        transform: 'translate(-50%, -50%)',
                        filter: 'brightness(0.6)'
                    }}
                >
                    <source src={video2} type="video/mp4" />
                </video>
                {/* Overlay for better text readability */}
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    zIndex: 0
                }}></div>

                <div className="container" style={{ position: 'relative', zIndex: 1, textAlign: 'center' }}>
                    <h1 style={{ fontSize: '4rem', marginBottom: '1rem', textShadow: '2px 2px 4px rgba(0,0,0,0.5)', color: '#FFFFFF' }}>Nos Tarifs</h1>
                    <p style={{ fontSize: '1.5rem', textShadow: '1px 1px 2px rgba(0,0,0,0.5)', color: '#FFFFFF' }}>Transparence et prix fixes</p>
                </div>
            </section>

            <div className="section container">
                <div style={{ textAlign: 'left', marginBottom: '4rem' }}>
                    <h2 style={{ fontSize: '2.5rem', marginBottom: '1.5rem', color: '#1e293b' }}>Nos tarifs</h2>
                    <p style={{ fontSize: '1.1rem', color: '#475569', maxWidth: '800px', lineHeight: '1.6' }}>
                        Chez 2ATP-MR, nous vous proposons des prix transparents et sans surprise. Grâce à notre calculateur en ligne, estimez en quelques secondes le coût de votre trajet selon vos besoins.
                    </p>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))', gap: '2rem' }}>
                    {/* Card 1: Week Day */}
                    <PricingCard
                        title="Lundi au samedi"
                        subtitle="(jusqu'à 12h)"
                        badge="08h00 → 19h00"
                        desc="Transfert aéroport – tarif de jour"
                        priceSmall="110 €"
                        priceLarge="150 €"
                    />

                    {/* Card 2: Week Night */}
                    <PricingCard
                        title="Lundi au samedi"
                        subtitle="(jusqu'à 12h)"
                        badge="19h00 → 08h00"
                        desc="Transfert aéroport – soirée et nuit"
                        priceSmall="150 €"
                        priceLarge="180 €"
                    />

                    {/* Card 3: Weekend Day */}
                    <PricingCard
                        title="Samedi 12h → Dimanche"
                        subtitle="& jours fériés"
                        badge="08h00 → 19h00"
                        desc="Transfert aéroport – tarif de jour (week-end)"
                        priceSmall="150 €"
                        priceLarge="200 €"
                    />

                    {/* Card 4: Weekend Night */}
                    <PricingCard
                        title="Samedi 12h → Dimanche"
                        subtitle="& jours fériés"
                        badge="19h00 → 08h00"
                        desc="Transfert aéroport – soirée et nuit (week-end)"
                        priceSmall="200 €"
                        priceLarge="230 €"
                    />
                </div>

                <div style={{ marginTop: '4rem', color: '#64748b', fontSize: '0.95rem', lineHeight: '1.6' }}>
                    <p>
                        Tarifs fixes pour transferts aéroport depuis Les Mureaux et environs. Suppléments éventuels : attentes prolongées, péages spécifiques, demandes particulières.
                    </p>
                </div>
            </div>
        </div>
    );
};

const PricingCard = ({ title, subtitle, badge, desc, priceSmall, priceLarge }) => (
    <div style={{
        backgroundColor: 'white',
        border: '1px solid #e2e8f0',
        borderRadius: '16px',
        padding: '2rem',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
    }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '1.5rem' }}>
            <h3 style={{ fontSize: '1.4rem', color: '#1e293b', fontWeight: '800', margin: 0, lineHeight: '1.2' }}>
                {title} <br /> {subtitle}
            </h3>
            <span style={{
                backgroundColor: '#164e63', // Dark greenish blue from image
                color: 'white',
                padding: '0.4rem 0.8rem',
                borderRadius: '999px',
                fontSize: '0.85rem',
                fontWeight: '600',
                whiteSpace: 'nowrap'
            }}>
                {badge}
            </span>
        </div>

        <p style={{ color: '#64748b', marginBottom: '2rem', fontSize: '1rem' }}>{desc}</p>

        <div style={{ display: 'flex', gap: '1rem', marginTop: 'auto' }}>
            <PriceBox label="Petit véhicule" price={priceSmall} />
            <PriceBox label="Grand véhicule" price={priceLarge} />
        </div>
    </div>
);

const PriceBox = ({ label, price }) => (
    <div style={{
        flex: 1,
        border: '2px dashed #e2e8f0',
        borderRadius: '12px',
        padding: '1.5rem 1rem',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
    }}>
        <span style={{ fontSize: '0.9rem', color: '#64748b', marginBottom: '0.5rem' }}>{label}</span>
        <span style={{ fontSize: '1.8rem', fontWeight: '800', color: '#0f172a' }}>{price}</span>
    </div>
);

export default Tarifs;
